// This file contains helper functions that directly relate to the DOM

// This function can be used to manually dispatch an event, for the purpose of
// triggering event listeners for behaviour that might not be captured natively
// ex: updates to an input value via JS
export const triggerEvent = (event, element) => {
    var newEvent = new Event(event, {
        bubbles: true,
        cancelable: true,
    });

    element.dispatchEvent(newEvent);
};

export const getSelectInputValue = (select) => {
    if (select.value) { return select.value; }
    if (select.selectize) { return select.selectize.getValue(); }

    const existingData = select.dataset.existing;
    if (existingData && existingData !== "null") { return JSON.parse(existingData).id; }

    return null;
};

/**
 * Focus and select all text inside a content-editable
 * element. For normal input elements, you can just use
 * `inputElement.select()`.
 *
 * @param {Node} contentEditableElement
 */
export function focusAndSelectAll(contentEditableElement) {
    contentEditableElement.focus();

    if (document.body.createTextRange) {
        // IE
        const range = document.body.createTextRange();
        range.moveToElementText(contentEditableElement);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(contentEditableElement);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

/**
Enables setting multiple attribute on an element at once. Does not
work with nested objects. Call with: setElementAttributes(element, {
    class: "foo",
    href: "link",
    target: "_blank"
})
@param {Node} el
@param {Object} attrs
 */
export function setElementAttributes(el, attrs) {
    Object.entries(attrs).forEach(([key, val]) => el.setAttribute(key, val));
}

// Helper to allow checkbox changes via JS to trigger event listeners
export function changeChecked(checkbox, value) {
    checkbox.checked = value;
    triggerEvent("change", checkbox);
}
